import UserInterviewsSquaredLarge from "./assets/blog/user_interviews_as_a_product_manager.png";
import UserSurveySquaredLarge from "./assets/blog/user_surveys_as_a_product_manager.png";
import UserTestingSquareLarge from "./assets/blog/beta_test_as_a_product_manager.png";
import hpwCEOCanCollaborateWithCTOSquareLarge from "./assets/blog/ceo_can_best_collaborate_with_cto.png";
import howToDoDiscoveryInterviewsCustomerInterview from "./assets/blog/discovery_interviews_recruit_the_right_users.png";
import howToDoDiscoveryInterviewsCustomerRightQuestions from "./assets/blog/discovery_interviews_ask_the_right_customer_interview_questions.png";
import DeadlySinsOfCustomeInterviews from "./assets/blog/7_deadly_sins_of_customer_interviews.png";
import IntroducingMagicAISurveys from "./assets/blog/introducing_Magic_AI_Surveys.png";
import CreateYourFirstAISurvey from "./assets/blog/create_your_first_AI_survey.png";
import StartupIdeaSquaredLarge from "./assets/blog/startup-idea.png";
import BlogVanessaDesi from "./assets/blog/blog_Vanessa_Desi_Damblemont.png";

import UserInterviewsSquared from "./assets/blog/user_interviews_as_a_product_manager_square.png";
import UserSurveySquared from "./assets/blog/user_surveys_as_a_product_manager_square.png";
import UserTestingSquare from "./assets/blog/beta_test_as_a_product_manager_square.png";
import hpwCEOCanCollaborateWithCTOSquareLargeSquare from "./assets/blog/ceo_can_best_collaborate_with_cto_square.png";
import howToDoDiscoveryInterviewsCustomerInterviewSquare from "./assets/blog/discovery_interviews_recruit_the_right_users_square.png";
import howToDoDiscoveryInterviewsCustomerRightQuestionsSquare from "./assets/blog/discovery_interviews_ask_the_right_customer_interview_questions_square.png";
import DeadlySinsOfCustomeInterviewsSquare from "./assets/blog/7_deadly_sins_of_customer_interviews_square.png";
import IntroducingMagicAISurveysSquared from "./assets/blog/introducing_Magic_AI_Surveys_square.png";
import CreateYourFirstAISurveyLarge from "./assets/blog/create_your_first_AI_survey_square.png";
import BlogVanessaDesiSquared from "./assets/blog/blog_Vanessa_Desi_Damblemont_square.png";

import StartupIdeaSquared from "./assets/startup-idea-squared.png";

export const getImage = (image, large) => {
  switch (image) {
    case "user-interviews-squared.png":
      return large ? UserInterviewsSquaredLarge : UserInterviewsSquared;
    case "user-survey-squared.png":
      return large ? UserSurveySquaredLarge : UserSurveySquared;
    case "user-testing-square.png":
      return large ? UserTestingSquareLarge : UserTestingSquare;
    case "startup-idea-squared.png":
      return large ? StartupIdeaSquaredLarge : StartupIdeaSquared;
    case "how-ceo-can-collaborate-with-cto.png":
        return large ? hpwCEOCanCollaborateWithCTOSquareLarge : hpwCEOCanCollaborateWithCTOSquareLargeSquare;
    case "how-to-do-discovery-interviews-customer-interview-questions.png":
      return large ? howToDoDiscoveryInterviewsCustomerRightQuestions : howToDoDiscoveryInterviewsCustomerRightQuestionsSquare;
    case "how-to-do-discovery-interviews-find-the-right-customers.png":
      return large ? howToDoDiscoveryInterviewsCustomerInterview : howToDoDiscoveryInterviewsCustomerInterviewSquare;
    case "7-deadly-sins-of-customer-interviews.png":
      return large ? DeadlySinsOfCustomeInterviews : DeadlySinsOfCustomeInterviewsSquare;
    case "introducing-magic-ai-surveys.png":
      return large ? IntroducingMagicAISurveys : IntroducingMagicAISurveysSquared;
    case "create-your-first-ai-survey.png":
      return large ? CreateYourFirstAISurvey : CreateYourFirstAISurveyLarge;
    case "how-to-build-better-products-by-creating-a-strong-story.png":
      return large ? BlogVanessaDesi : BlogVanessaDesiSquared;
  }

};

const blogPreview = [
  {
    id: 1,
    image: "user-interviews-squared.png",
    title: "How to conduct user interviews as a product manager",
    body: "How to conduct user interviews. Learn how to conduct great user interviews. Understand user needs, validate assumptions and uncover hidden insights.",
    link: "/blog/how-to-conduct-user-interviews-as-a-product-manager",
    size: "small",
  },
  {
    id: 2,
    image: "user-survey-squared.png",
    title: "How to conduct user surveys as a product manager",
    body: "How to do user surveys. Learn how to conduct user feedback surveys to measure customer satisfaction, capture likes and make data driven decisions.",
    link: "/blog/how-to-conduct-user-surveys-as-a-product-manager",
    size: "small",
  },
  {
    id: 3,
    image: "user-testing-square.png",
    title: "How to beta test as a product manager",
    body: "Learn how to conduct beta testing to create a better product, increase user adoption, and build stronger relationships with your users.",
    link: "/blog/beta-testing-as-a-product-manager",
    size: "small",
  },
  /*{
    id: 4,
    image: "startup-idea-squared.png",
    title: "How to validate your product idea: Idea validation process",
    body: "For many founders, it's a bit of a puzzle to figure out how to validate a B2B idea.",
    link: "/blog/how-to-validate-startup-idea",
    size: "large",
  },*/
  {
    id: 5,
    image: "how-ceo-can-collaborate-with-cto.png",
    title: "How CEO's can best collaborate with CTO's to drive business growth",
    body: "Learn the best practices for fruitful CEO & CTO collaboration. Understand how to avoid possible pitfalls. ",
    link: "/blog/how-ceo-can-collaborate-with-cto",
    size: "small",
  },
  {
    id: 6,
    image: "how-to-do-discovery-interviews-find-the-right-customers.png",
    title: "How to do discovery interviews. Part 1: Recruit the right customers",
    body: "How to recruit the right participants for discovery interviews. Understand your customers better. Improve your discovery interview skills.",
    link: "/blog/how-to-do-discovery-interviews-find-the-right-customers",
    size: "small",
  },
  {
    id: 7,
    image: "how-to-do-discovery-interviews-customer-interview-questions.png",
    title: "How to do discovery interviews. Part 2: Ask the right customer interview questions",
    body: "Learn how to ask the right customer interview questions. Complete with examples. Top tips on uncovering deeper insights from your customers.",
    link: "/blog/how-to-do-discovery-interviews-customer-interview-questions",
    size: "small",
  },
  {
    id: 8,
    image: "7-deadly-sins-of-customer-interviews.png",
    title: "6 biggest customer interview mistakes",
    body: "Discover the 6 biggest mistakes when conducting customer interviews. Understand the potential pitfalls and learn how to avoid them.",
    link: "/blog/6-biggest-customer-interview-mistakes",
    size: "small",
  },
  {
    id: 9,
    image: "introducing-magic-ai-surveys.png",
    title: "[Video] Introducing Magic AI Surveys",
    body: "Introducing Magic Feedback's AI Survey. Learn how our innovative AI survey works. Uncover deeper customer insights with real-time AI follow-up questions",
    link: "/blog/demo/introducing-magic-ai-surveys",
    size: "small",
  },
  {
    id: 9,
    image: "create-your-first-ai-survey.png",
    title: "[Video] Create your first AI survey",
    body: "Learn how to create your first AI survey. Understand how you can receive more in-depth feedback from your customers with AI generated follow-up questions. ",
    link: "/blog/demo/create-your-first-ai-survey",
    size: "small",
  },
  {
    id: 10,
    image: "how-to-build-better-products-by-creating-a-strong-story.png",
    title: "How to build better products by creating a strong story",
    body: "Thought Leadership article with Vanessa Desi Damblemont. Understand the importance of creating a strong story, for building products that customers love.",
    link: "/blog/though-leadership/how-to-build-better-products-by-creating-a-strong-story",
    size: "small",
  },
];

export default blogPreview;
